import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import { useGetMaster } from '../../../../api/masters/masters';
import { useGetScheduleMasters } from '../../../../api/schedules/schedules';
import { useDefaultOptions } from '../../../../hooks/api';
import { MasterSchedule } from './MasterSchedule';

/**
 * タブタイトル
 * @returns
 */
function Title() {
  // 言語情報
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>{t('CMS-POC|マスタ情報')}</title>
    </Helmet>
  );
}
function MasterSchedulePage() {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { masterVersionId } = useParams();
  const options = useDefaultOptions(language);

  const masterResponse = useGetMaster(Number(masterVersionId), options);
  const { data, refetch } = useGetScheduleMasters(options);

  if (masterVersionId == null) {
    return <div id="main">{t('この URL は存在しません。')}</div>;
  }

  const master = masterResponse.data?.data;
  if (!master) {
    return <div id="main">{t('お待ちください。')}</div>;
  }

  return (
    <div id="main">
      <Title />
      {data?.data.schedule_master_items && (
        <MasterSchedule scheduleMasters={data?.data.schedule_master_items} refetch={refetch} />
      )}
    </div>
  );
}

export default MasterSchedulePage;
